import environmentDev from './environment.dev';
import environmentProd from './environment.prod';
import environmentTest from './environment.testing';
import environmentStaging from './environment.staging';
import environmentStagingCy from './environment.staging-cy';
import environmentTestingCy from './environment.testing-cy';

export type Environments = {
  development: Environment;
  production: Environment;
  test: Environment;
  staging: Environment;
  stagingCy: Environment;
  testingCy: Environment;
};

const environments: Environments = {
  development: environmentDev,
  production: environmentProd,
  test: environmentTest,
  staging: environmentStaging,
  stagingCy: environmentStagingCy,
  testingCy: environmentTestingCy,
};

export type FeatureFlags = {
  [key: string]: boolean;
};

export type Environment = {
  URL: string;
  CLIENT_ID: string;
  API_URL:
    | 'http://localhost:13980/api-'
    | 'http://demo.ventionteams.com:11980/api-'
    | 'http://demo.ventionteams.com:13380/api-'
    | 'https://mg.ventionteams.com/api-';
  VERSION: string;
  WOD_URL: 'https://employees-wod.ventionteams.com';
  AUTH_URL: string;
  TEST_AUTH_URL: string;
  featureFlags: FeatureFlags;
  isProduction?: boolean;
  auth0Enabled?: boolean;
};

export const environment: Environment =
  environments[process.env.REACT_APP_HOST_ENV || process.env.NODE_ENV];
